import { addClassToElement, removeClassToElement, hasClassElement } from '@jspartials/class-list-utils';

const BODY_SELECTOR = '.js-body';
const CHAT_SELECTOR = '.embeddedServiceHelpButton';
const INSERTABLE_ELEM_SELECTOR = '.js-insert-chat-online';
const VISIBLE_STATUS_CLASSNAME = 'is-visible';
const SCROLLED_TO_BOTTOM_STATUS_CLASSNAME = 'is-scrolled-to-bottom';

const maxInitAttempts = 3;
const waitingTimeBetweenInitAttempts = 900; // milliseconds
const maxRelocationAttempts = 5;
const waitingTimeBetweenRelocationAttempts = 1000; // milliseconds
let $chat = null;
let chatEstablished = false;
let last_known_scroll_position = 0;
let ticking = false;
const $body = document.querySelector(BODY_SELECTOR);

const chatScrolling = scroll_pos => {
  if ((window.innerHeight + scroll_pos) >= document.body.scrollHeight) {
    if (!hasClassElement($body, SCROLLED_TO_BOTTOM_STATUS_CLASSNAME)) {
      addClassToElement($body, SCROLLED_TO_BOTTOM_STATUS_CLASSNAME);
    }
  } else {
    if (hasClassElement($body, SCROLLED_TO_BOTTOM_STATUS_CLASSNAME)) {
      removeClassToElement($body, SCROLLED_TO_BOTTOM_STATUS_CLASSNAME);
    }
  }
}

function getChatConfiguration() {
  let chatConfiguration = {};
  const chatPreferencesParsed = JSON.parse(chatPreferences);

  try {
    if (chatPreferencesParsed.hasOwnProperty(countryForChat)) {
      chatConfiguration = chatPreferencesParsed[countryForChat];
    }
  } catch (e) {}

  return chatConfiguration;
}

const initESW = chatConfiguration => {
  embedded_svc.settings.displayHelpButton = true;
  embedded_svc.settings.language = languageForChat;
  embedded_svc.settings.defaultMinimizedText = 'CHAT';
  embedded_svc.settings.enabledFeatures = ['LiveAgent'];
  embedded_svc.settings.entryFeature = 'LiveAgent';
  embedded_svc.init(
    chatConfiguration.init_first_domain,
    chatConfiguration.init_second_domain,
    chatConfiguration.init_esw_domain,
    chatConfiguration.console_service_id,
    chatConfiguration.country,
    {
      baseLiveAgentContentURL: chatConfiguration.base_live_agent_content_url,
      deploymentId: chatConfiguration.deployment_id,
      buttonId: chatConfiguration.button_id,
      baseLiveAgentURL: chatConfiguration.base_live_agent_url,
      eswLiveAgentDevName: chatConfiguration.esw_live_agent_dev_name,
      isOfflineSupportEnabled: chatConfiguration.is_offline_support_enabled
    }
  );
};

const relocationChat = (
  attemptNumber = 0,
  waitingTime = waitingTimeBetweenRelocationAttempts
) => {
  $chat = document.querySelector(CHAT_SELECTOR);

  if ($chat && !chatEstablished) {
    const $insertableElem = document.querySelector(INSERTABLE_ELEM_SELECTOR);
    $insertableElem.appendChild($chat);
    addClassToElement($chat, VISIBLE_STATUS_CLASSNAME);
    chatEstablished = true;
  } else if (attemptNumber < maxRelocationAttempts) {
    setTimeout(() => {
      relocationChat(attemptNumber + 1);
    }, waitingTime);
  }
};

const tryInitChat = (
  attemptNumber = 0,
  waitingTime = waitingTimeBetweenInitAttempts
) => {
  var chatConfiguration = getChatConfiguration();

  if (chatConfiguration) {
    if (chatConfiguration.is_visible) {
      if (window.embedded_svc) {
        initESW(chatConfiguration);
        relocationChat();
      } else if (attemptNumber < maxInitAttempts) {
        setTimeout(() => {
          tryInitChat(attemptNumber + 1, waitingTime - 100);
        }, waitingTime);
      } else {
        var s = document.createElement('script');
        s.setAttribute('src', scriptAttribute_value);
        s.onload = function() {
          initESW(chatConfiguration);
        };
        document.body.appendChild(s);
      }
    }
  }
};

const initChat = () => {
  tryInitChat();
};

document.addEventListener('scroll', function() {
  last_known_scroll_position = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function() {
      chatScrolling(last_known_scroll_position);
      ticking = false;
    });
  }
  ticking = true;
});

initChat();
